import React, { useContext, useRef, useState } from "react";
import "./navbar.css";
import { RxHamburgerMenu, RxCross1 } from "react-icons/rx";

import { MdLightMode, MdDarkMode } from "react-icons/md";
import { Theme } from "../App";

function Navbar({ appRef }) {
  const { theme, setTheme } = useContext(Theme);
  const [isMenu, setIsMenu] = useState(false);
  const menuRef = useRef();

  const toggleTheme = () => {
    if (theme === "light") setTheme("dark");
    else setTheme("light");
  };

  const toggleMenu = () => {
    if (window.visualViewport.width < 700) {
      if (isMenu) {
        menuRef.current.style.transform = "";
        appRef.current.style.overflow = "";
      } else {
        menuRef.current.style.transform = "translateX(0)";
        appRef.current.style.overflow = "hidden";
      }
      setIsMenu(!isMenu);
    }
  };

  return (
    <div id="navbar-comp" className={`navbar-comp-${theme}`}>
      <h1 className={`navbar-comp-logo  navbar-comp-logo-${theme}`}>
        Ali Ishaq
      </h1>
      <ul className="navbar-comp-links" ref={menuRef}>
        <li>
          <RxCross1 size={"30px"} onClick={toggleMenu} />
        </li>
        <li className={`nav-links nav-links-${theme}`} onClick={toggleMenu}>
          <a href="#homepage-comp">Home</a>
        </li>
        <li className={`nav-links nav-links-${theme}`} onClick={toggleMenu}>
          <a href="#homepage-comp">About</a>
        </li>
        <li className={`nav-links nav-links-${theme}`} onClick={toggleMenu}>
          <a href="#projects-comp">Projects</a>
        </li>
        <li className={`nav-links nav-links-${theme}`} onClick={toggleMenu}>
          <a href="#contact-comp">Contact</a>
        </li>
        <li className={`nav-links nav-links-${theme} `} onClick={toggleTheme}>
          {theme === "light" ? (
            <MdDarkMode size={"30px"} color="#2d2e32" />
          ) : (
            <MdLightMode
              size={"30px"}
              color={theme === "light" ? "#2d2e32" : "#f9f9f9"}
            />
          )}
        </li>
      </ul>
      <RxHamburgerMenu
        size={"30px"}
        className="hamburger-close"
        onClick={toggleMenu}
      />
    </div>
  );
}

export default Navbar;
